export default __webpack_public_path__ + "a6c00dab10049ae226ec257754677440.png";